export enum WorkflowType {
  EVENT_BASED = 'event_based',
  SCHEDULED = 'scheduled',
  AUTOMATION = 'automation',
  TICKET_EVENT = 'ticket_event',
}
